import { cn } from "@/lib/utils";

/**
 * Loading placeholder block. Combines a slow opacity breathe (so it still
 * visibly reads as "loading" between sweeps, not a static grey box) with a
 * brighter shimmer band sweeping across on top of it — one animation alone
 * reads as either "stuck" (pulse only) or "flickers once and goes flat"
 * (shimmer only). Never render fake/sample data inside a skeleton.
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      role="status"
      aria-label="loading"
      className={cn(
        "relative animate-pulse overflow-hidden rounded-md bg-bg-surface",
        "before:absolute before:inset-0 before:animate-shimmer",
        "before:bg-gradient-to-r before:from-transparent before:via-bg-elevated before:to-transparent",
        className,
      )}
      {...props}
    />
  );
}
